export default "__VITE_ASSET__bdad1058__"